export default "__VITE_ASSET__331966aa__"